module.exports = __webpack_public_path__ + "media/packingstation.c0c33021.mp4";